// src/modules/app-views/invoices/pages/Document/tabs/PreviewTab/ConsumerSection.jsx
// *******************************************************************************
// CONSUMER SECTION - DANFE NFC-e
// *******************************************************************************
// Displays consumer/recipient data: name, CPF/CNPJ.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { parseCpfToDisplay, parseCnpjToDisplay, isCpfOrCnpj } from 'utils/helpers';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ConsumerSection = ({ data }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const recipient = data?.recipient || data?.recipientEntity || {};
  const isFinalConsumer = data?.isFinalConsumer || data?.finalConsumer;

  // Extract recipient data
  const name = recipient.name || recipient.razaoSocial || '';
  const cpfCnpj = recipient.cpfCnpj || recipient.cpf || recipient.cnpj || '';

  // Format document
  const documentType = isCpfOrCnpj(cpfCnpj);
  const formattedDocument =
    documentType === 'cpf' ? parseCpfToDisplay(cpfCnpj) : parseCnpjToDisplay(cpfCnpj);

  // Check if consumer is identified
  const isIdentified = !!(cpfCnpj || name);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="danfe-section danfe-consumer">
      <Text strong style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>
        CONSUMIDOR
      </Text>

      {isIdentified ? (
        <div>
          {/* Document (CPF/CNPJ) */}
          {formattedDocument && (
            <Text style={{ fontSize: 11, display: 'block' }}>
              {documentType === 'cpf' ? 'CPF' : 'CNPJ'}: {formattedDocument}
            </Text>
          )}

          {/* Name */}
          {name && <Text style={{ fontSize: 11, display: 'block' }}>{name}</Text>}
        </div>
      ) : (
        <Text type="secondary" style={{ fontSize: 11 }}>
          {translateX('consumer_not_identified')}
        </Text>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ConsumerSection;

// *******************************************************************************
// HELPERS
// *******************************************************************************
